// Vendors
import React, { useState, useEffect } from 'react';
import axios from 'axios';

// Components
import { Loader } from '../components';

// Helpers
import { formatCompletionDate } from '../components/helpers';

const Dashboard = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [projectStatuses, setProjectStatuses] = useState([]);
  const [projectStatusesLoading, setProjectStatusesLoading] = useState([]);

  const getProjectStatusesDropdown = () => {
    const statuses = [
      'In Progress',
      'Submitted',
      'Incomplete',
      'Approved',
      'Completed'
    ];

    return statuses.map(
      (status, index) =>
        projectStatuses.includes(status) && (
          <option key={index} value={status}>
            {status}
          </option>
        )
    );
  };

  useEffect(() => {
    setLoading(true);

    axios({
      method: 'post',
      url: `${window.wlPipConfig.ajaxUrl}?action=wl_pip_get_projects`
    })
      .then(({ data: { success, data } }) => {
        if (success) setProjects(data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!projects.length) return;

    setProjectStatusesLoading(true);

    let statuses = [];

    projects.map(
      ({ status }) => !statuses.includes(status) && statuses.push(status)
    );

    setProjectStatuses([...statuses]);
    setProjectStatusesLoading(false);
  }, [projects]);

  return (
    <div className="grid grid--gutter-vertical grid--row-stretch">
      {loading && <Loader />}
      {!loading && projects.length > 0 && (
        <>
          <div className="grid__col-xs-12">
            <div
              className={`form__select form__select--lg form__select--no-shadow ${
                projectStatusesLoading ? 'is-loading' : ''
              }`}
            >
              <select
                className="form__input form__input--lg"
                onChange={(event) => setFilter(event.target.value)}
              >
                <option value="">-- Filter by Project Status --</option>
                {getProjectStatusesDropdown()}
              </select>
            </div>
          </div>

          {projects.map((project, index) => {
            if (filter && filter !== project.status) return;

            return (
              <div key={index} className="grid__col-xs-12 grid__col-xl-6">
                <div
                  className={`card-project card-project--${project.status.toLowerCase()}`}
                >
                  <div className="card-project__address">
                    <div className="card-project__street">
                      {project.address}
                    </div>
                    <span>
                      {project.city}, {project.state} {project.zipcode}
                    </span>
                  </div>
                  <div className="card-project__status">
                    <span className="card-project__status-indicator">
                      {project.status}
                    </span>
                    {project.new_messages > 0 && (
                      <div className="card-project__messages">
                        {project.new_messages} Unread{' '}
                      </div>
                    )}
                  </div>
                  <div className="card-project__completion-date">
                    <div>
                      Complete Date:{' '}
                      <span>
                        {formatCompletionDate(project.completion_date)}
                      </span>
                    </div>
                  </div>
                  <div className="card-project_qualify-for">
                    <div>
                      Qualifying for{' '}
                      <span className="card-project_qualify-amount">
                        {parseInt(project.appliance_total_incentives) > 0
                          ? `$${parseInt(
                              project.appliance_total_incentives
                            ).toLocaleString()}`
                          : 'TBD'}
                      </span>
                    </div>
                  </div>
                  <div className="card-project__view-details">
                    <a
                      href={project.permalink}
                      className="btn btn--link btn--sm btn--has-arrow module-hover-root"
                    >
                      <span className="btn__content">
                        <span className="btn__text">View/Edit Details</span>
                        <span className="btn__arrow arrow"></span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      )}

      {!loading && (
        <div className="grid__col-xs-12 grid__col-xl-6">
          <a
            href="/pcip/add-project/"
            className="card-project card-project--add-project"
          >
            <div className="card-project__add">Add a Project</div>
          </a>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
